 import * as Cesium from 'cesium';
import { Injectable } from '@angular/core';
import {
  Viewer,
  ProviderViewModel,
  ImageryProvider,
  MapboxStyleImageryProvider
} from 'cesium';
import { BaseMapEntity } from './base-map-entity.service';
import { CameraService } from './camera.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailsWindowComponent } from '../../components/shared/details-window/details-window.component';

@Injectable({
  providedIn: 'root'
})
export class GlobeService {

  private viewer?: Viewer;
  private clickHandler?: (scope: any, mapEntity: any) => void;
  private leafletZoomHandler?: (zoomLevel: number) => void;
  private leafletHandler: any;


constructor() {}

  setViewer(viewer: Viewer) {
    this.viewer = viewer;
  }

  getViewer(): Viewer | undefined {
    return this.viewer;
  }

  setMapboxImageryProviders() {
    if (!this.viewer || !this.viewer.baseLayerPicker) return;

    const imageryViewModels: ProviderViewModel[] = [
      new ProviderViewModel({
        name: 'Mapbox Satellite',
        iconUrl: '/assets/Cesium/Widgets/Images/ImageryProviders/mapboxSatellite.png',
        tooltip: 'Mapbox Satellite \nhttps://www.mapbox.com/about/maps/',
        creationFunction: () => new MapboxStyleImageryProvider({
          styleId: 'satellite-v9',
          maximumLevel: 22,
          accessToken: 'pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ'
        })
      }),
      new ProviderViewModel({
        name: 'Mapbox Satellite with Streets',
        iconUrl: '/assets/Cesium/Widgets/Images/ImageryProviders/mapboxSatellite.png',
        tooltip: 'Mapbox Satellite with Streets \nhttps://www.mapbox.com/about/maps/',
        creationFunction: () => new MapboxStyleImageryProvider({
          styleId: 'satellite-streets-v11',
          maximumLevel: 22,
          accessToken: 'pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ'
        })
      }),
      new ProviderViewModel({
        name: 'Mapbox Streets',
        iconUrl: '/assets/Cesium/Widgets/Images/ImageryProviders/mapboxStreets.png',
        tooltip: 'Mapbox Streets \nhttps://www.mapbox.com/about/maps/',
        creationFunction: () => new MapboxStyleImageryProvider({
          styleId: 'streets-v11',
          maximumLevel: 22,
          accessToken: 'pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ'
        })
      })
    ];

    this.viewer.baseLayerPicker.viewModel.imageryProviderViewModels = imageryViewModels;

    this.viewer.baseLayerPicker.viewModel.selectedImagery = imageryViewModels[2]
  }

  changeBaseLayer(provider: ImageryProvider) {
    if (this.viewer) {
      this.viewer.imageryLayers.removeAll();
      this.viewer.imageryLayers.addImageryProvider(provider);
    }
  }
  setClickHandler(handler: (scope: any, mapEntity: any) => void): void {
    this.clickHandler = handler;
  }

  clearClickHandler(): void {
    this.clickHandler = undefined;
  }

  setLeafletZoomHandler(handler: (zoomLevel: number) => void): void {
    this.leafletZoomHandler = handler;
  }

  handleClick(scope: any, mapEntity: any): void {
    if (this.clickHandler) {
      this.clickHandler(scope, mapEntity);
    } else {
      this.defaultHandler(scope , mapEntity );
    }
  }

  defaultHandler(scope:any,mapEntity: any): void {
    if (mapEntity) {
      mapEntity.viewDetailsWindow(mapEntity);
     }
  }

  setLeaflet(leafletHandler: any): void {
    this.leafletHandler = leafletHandler;
    // If you have a CoreService, inject and use it here
    // this.coreService.setLeafletViewer(this.leafletHandler);

    this.leafletHandler.on('zoomend', () => {
      const zoomLev = this.leafletHandler.getZoom();
      if (this.leafletZoomHandler) {
        this.leafletZoomHandler(zoomLev);
      }
    });
  }

  showCesium(): void {
    // Implement Cesium show logic if needed
    // e.g., document.getElementById('leafletContainer')?.style.display = 'none';
  }

  showLeaflet(): void {
    // Implement Leaflet show logic if needed
    // e.g., this.leafletHandler.fitWorld();
    // document.getElementById('leafletContainer')?.style.display = 'block';
  }
   
}
